import { createContext } from 'react';
import type { EventWithCircuit } from '../api/eventsService';

export interface EventContextType {
  selectedEvent: EventWithCircuit | null;
  setSelectedEvent: (event: EventWithCircuit | null) => void;
  /** The stored event key from localStorage (used to restore selection on load) */
  storedEventKey: string | null;
}

export const EventContext = createContext<EventContextType | undefined>(undefined);

